const WEBHOOK_LIST = {
  LIST_PAGE_HEADER_TITLE: 'لیست وب‌‌ هوک های ایجاد شده',
  LIST_PAGE_HEADER_DESCRIPTION:
    'در این بخش، لیستی از آدرس‌هایی که برای آن‌ها قابلیت وب‌هوک فعال شده است را می‌بینید.',
  LIST_PAGE_HEADER_BTN_LABEL: 'ایجاد وب هوک جدید',
  LIST_PAGE_TABLE_COL_1_HEAD: 'نام وبسایت',
  LIST_PAGE_TABLE_COL_2_HEAD: 'آدرس وب‌هوک',
  LIST_PAGE_TABLE_COL_3_HEAD: 'رویدادها',
  LIST_PAGE_TABLE_COL_4_HEAD: 'ویرایش',
  LIST_PAGE_NO_WEBHOOK: 'وب‌هوکی ایجاد نشده است',

  LIST_PAGE_EVENT_MSG: 'پیغام جدید',
  LIST_PAGE_EVENT_CONV: 'گفتگوی جدید',
  LIST_PAGE_SWITCH_INACTIVE: 'غیرفعال',
  LIST_PAGE_SWITCH_ACTIVE: 'فعال',
};

export default WEBHOOK_LIST;
